// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_34pxb3XgSd_HSC9dWJyDo","spin":"_1yxYwqL8ohYQqO3ppWWEg1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.css
// module id = 671
// module chunks = 0